function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { getPropertyFeatureForType, PropertyFeature, AllExceptBusinessListingTypeKeys } from '@domain-group/fe-allhomes-library/lib/node';
import { parseSlugs } from '../../utils/parse-slugs';
import { MultiValueSearchQueryField } from '../multi-value-search-query-field';
export class ListingFeaturesFilter extends MultiValueSearchQueryField {
  get validListingTypes() {
    return AllExceptBusinessListingTypeKeys;
  }
  constructor(searchOptions, value) {
    var available = getPropertyFeatureForType(searchOptions.listingType).map(item => item.name).map(key => PropertyFeature[key]);
    super(searchOptions, available, value);
    _defineProperty(this, "urlSlug", ListingFeaturesFilter.urlSlug);
  }
  static fromUrlParameters(searchOptions, q) {
    return new ListingFeaturesFilter(searchOptions, parseSlugs(PropertyFeature, q[ListingFeaturesFilter.urlSlug]));
  }
}
_defineProperty(ListingFeaturesFilter, "urlSlug", 'listingfeatures');